import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';

/**
 * Protège une route : bloque le rendu pendant le chargement de la session
 * (évite les 401 en rafale au démarrage), redirige vers /login si non
 * connecté, et vers son propre espace si le rôle ne correspond pas.
 */
function RequireAuth({ role, children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="auth-loading">Chargement...</div>;
  }
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  if (role && user.role !== role) {
    return <Navigate to={user.role === 'superadmin' ? '/admin' : '/'} replace />;
  }
  return children;
}

export default RequireAuth;
